import React from 'react';
import { Box, Typography, Card } from '@mui/material';
import { Flag } from '@/static';
import styles from './styles';

type LiveEditorsProps = {
  users: number;
};

const LiveEditors = ({ users }: LiveEditorsProps) => {
  const getTitleText = () => {
    if (users === 0) return 'No other Editors';
    if (users === 1) return '1 more Editor';
    return `${users} more Editors`;
  };

  const getDescriptionText = () => {
    if (users === 0) {
      return 'Δεν υπάρχουν άλλοι χρήστες που επεξεργάζονται τα ίδια events αυτή τη στιγμή.';
    }
    if (users === 1) {
      return 'Υπάρχει άλλος 1 χρήστης που επεξεργάζεται τα ίδια events αυτή τη στιγμή.';
    }
    return `Υπάρχουν άλλοι ${users} χρήστες που επεξεργάζονται τα ίδια events αυτή τη στιγμή.`;
  };

  return (
    <Card sx={styles.card}>
      <Box sx={styles.outerBox}>
        <Flag />
      </Box>

      <Box sx={styles.boxContent}>
        <Box sx={styles.boxInner}>
          <Box sx={styles.editors} />
          {getTitleText()}
        </Box>

        <Typography variant="body2" sx={styles.text}>
          {getDescriptionText()}
        </Typography>
      </Box>
    </Card>
  );
};

export default LiveEditors;
